const capitalCase = (string) => {
  return string && string.split('-').map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1)
  }).join('-')
}

export { capitalCase, }



// WEBPACK FOOTER //
// ./src/app/filters/capitalCase.js